module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"writing_instruction":"写作指令：","quick_command":"快捷指令"},"en":{"writing_instruction":"Writing Instruction:","quick_command":"Instruction"}}')
  delete Component.options._Ctor
}
